import { lazy, Suspense } from "react";
import "@fontsource/barlow-condensed/600.css";
import "@fontsource/dm-sans/400.css";
import "@fontsource/dm-sans/600.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, Navigate, useLocation } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { DemoBanner, Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { SmoothScroll } from "./components/SmoothScroll";
import Home from "./pages/Home";
const ServicePage = lazy(() => import("./pages/ServicePage"));
const ServicesIndex = lazy(() => import("./pages/ServicePage").then((m) => ({ default: m.ServicesIndex })));
const RepairVsReplace = lazy(() => import("./pages/RepairVsReplace"));
const Symptoms = lazy(() => import("./pages/Guides").then((m) => ({ default: m.Symptoms })));
const CostFactors = lazy(() => import("./pages/Guides").then((m) => ({ default: m.CostFactors })));
const AnswerHub = lazy(() => import("./pages/Hub").then((m) => ({ default: m.AnswerHub })));
const ServiceArea = lazy(() => import("./pages/Hub").then((m) => ({ default: m.ServiceArea })));
const IllustrativeWork = lazy(() => import("./pages/Hub").then((m) => ({ default: m.IllustrativeWork })));
const Contact = lazy(() => import("./pages/Contact"));
const Legal = lazy(() => import("./pages/Legal"));
const NotFound = lazy(() => import("./pages/NotFound"));

const HtmlRedirect = () => {
  const { pathname } = useLocation();
  if (!pathname.endsWith(".html")) return null;
  const to = pathname.replace(/(index)?\.html$/, "").replace(/\/$/, "") || "/";
  return <Navigate to={to} replace />;
};

const Layout = () => (
  <>
    <HtmlRedirect />
    <a href="#main" className="skip-link" data-testid="skip-link">Skip to main content</a>
    <SmoothScroll />
    <DemoBanner />
    <Header />
    <main id="main" tabIndex={-1}>
      <Suspense fallback={<div className="min-h-screen bg-bone2" />}>
        <Outlet />
      </Suspense>
    </main>
    <Footer />
  </>
);

const LEGAL = ["about-this-demonstration", "privacy-policy", "terms-of-use", "accessibility-statement"];

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="services" element={<ServicesIndex />} />
            <Route path="services/:slug" element={<ServicePage />} />
            <Route path="guides/repair-vs-replace" element={<RepairVsReplace />} />
            <Route path="guides/furnace-symptoms" element={<Symptoms />} />
            <Route path="guides/furnace-cost-factors" element={<CostFactors />} />
            <Route path="answer-hub" element={<AnswerHub />} />
            <Route path="service-area" element={<ServiceArea />} />
            <Route path="illustrative-work" element={<IllustrativeWork />} />
            <Route path="contact" element={<Contact />} />
            {LEGAL.map((s) => <Route key={s} path={s} element={<Legal slug={s} />} />)}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
